export const CATEGORIES = [
  { id: 'perruques', label: 'Perruques', sizes: ['Courte', 'Mi-longue', 'Longue', '10"', '12"', '14"', '16"', '18"', '20"', '22"', '24"'] },
  { id: 'sacs', label: 'Sacs Femme', sizes: ['Mini', 'Petit', 'Moyen', 'Grand', 'Unique'] },
  { id: 'baskets', label: 'Baskets', sizes: ['36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46'] },
  { id: 'jeans', label: 'Jeans', sizes: ['28', '29', '30', '31', '32', '33', '34', '36', '38'] },
  { id: 'tshirts', label: 'T-shirts', sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'] },
  { id: 'vestes', label: 'Vestes', sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'] },
  { id: 'robes', label: 'Robes & Jupes', sizes: ['XS', 'S', 'M', 'L', 'XL'] },
  { id: 'accessoires', label: 'Casquettes & Accessoires', sizes: ['Unique'] },
  { id: 'friperie', label: 'Friperie', sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'Unique'] },
  { id: 'beaute', label: 'Beauté & Cosmétiques', sizes: [] },
  { id: 'bijoux', label: 'Bijoux & Montres', sizes: [] },
  { id: 'electronique', label: 'Électronique', sizes: [] },
  { id: 'telephones', label: 'Téléphones', sizes: [] },
  { id: 'maison', label: 'Maison & Déco', sizes: [] },
  { id: 'enfants', label: 'Enfants & Bébé', sizes: [] },
  { id: 'alimentation', label: 'Alimentation', sizes: [] },
  { id: 'autre', label: 'Autre (tout produit légal)', sizes: [] },
];

export const catLabel = (id) => CATEGORIES.find((c) => c.id === id)?.label || 'Autre';
export const catSizes = (id) => CATEGORIES.find((c) => c.id === id)?.sizes || [];

export const CategoryBadge = ({ category, size, brand, className = '' }) => (
  <span className={`inline-flex items-center gap-1.5 text-xs ${className}`}>
    <span data-testid="product-category" className="px-2 py-0.5 rounded-full bg-rose-500/15 border border-rose-500/30 text-rose-300 font-semibold">
      {catLabel(category)}
    </span>
    {size && <span data-testid="product-size" className="px-2 py-0.5 rounded-full bg-slate-800 border border-slate-700 text-slate-200">{category === 'perruques' ? 'Longueur' : 'Taille'} {size}</span>}
    {brand && <span className="text-slate-400">{brand}</span>}
  </span>
);
